import React, { createContext, useContext, useState, useEffect } from 'react';
import { superAdminAPI } from '../services/api';
import { useAuth } from './AuthContext';

const FeatureContext = createContext(null);

export function FeatureProvider({ children }) {
  const { user } = useAuth();
  const [features, setFeatures] = useState([]);
  const [plan, setPlan] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setFeatures([]); setPlan(''); setLoading(false); return; }
    superAdminAPI.companyFeatures()
      .then(res => {
        setFeatures(res.data.features || []);
        setPlan(res.data.plan || '');
      })
      .catch(() => setFeatures([]))
      .finally(() => setLoading(false));
  }, [user]);

  const hasFeature = (feature) => {
    if (!user) return false;
    if (user.role === 'super_admin') return true;
    // If no feature list loaded yet or empty (loading state), show everything
    if (features.length === 0 && loading) return true;
    // Default features always enabled
    const ALWAYS_ON = ['dashboard', 'masters', 'parties'];
    if (ALWAYS_ON.includes(feature)) return true;
    return features.includes(feature);
  };

  return (
    <FeatureContext.Provider value={{ features, plan, loading, hasFeature }}>
      {children}
    </FeatureContext.Provider>
  );
}

export function useFeatures() {
  const context = useContext(FeatureContext);
  if (!context) throw new Error('useFeatures must be used within FeatureProvider');
  return context;
}
